import React, { FC, useState } from 'react'
import * as yup from 'yup'
import axios, { AxiosResponse } from 'axios'
import { api } from 'config'
import {
  constants,
  errorMsg,
  processErrorMsg,
  removeFocusFromField,
  storage,
} from 'utils'
import { BaseLayout, Loader } from 'components'
import { ForgotLoginNameForm, EmailSentConfirmation } from './components'

const ForgotLoginName: FC = () => {
  const [transaction, setTransaction] = useState<any | {}>({})
  const [showLoader, setShowLoader] = useState(false)
  const [serviceError, setServiceError] = useState('')

  const processSuccess = (response: any) => {
    setShowLoader(false)
    setTransaction(response)
  }

  const processError = (
    e: any,
    module: string,
    moduleDescription: string = '',
  ) => {
    setShowLoader(false)
    setServiceError(processErrorMsg(e, module, moduleDescription))
  }

  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    storage.setUser(values.email)

    removeFocusFromField()
    setSubmitting(true)
    setShowLoader(true)
    setServiceError('')

    try {
      const response: AxiosResponse = await axios.get(
        api.recoverUsername(values.email),
      )

      if (response.status >= 400 && response.status < 600) {
        throw response
      }

      processSuccess(response.data)
    } catch (e: any) {
      processError(e?.response?.data || e, 'Forgot Login Name')
    }

    setSubmitting(false)
  }

  let formContent: any

  if (transaction.status === constants.OKTA_API_STATUS.RECOVERED_USERNAME) {
    formContent = (
      <EmailSentConfirmation
        transaction={transaction}
        serviceError={serviceError}
      />
    )
  } else {
    const initialValues: any = {
      email: '',
    }

    const validationSchema: any = yup.object().shape({
      email: yup
        .string()
        .required(errorMsg.requiredField('Email'))
        .email('Enter valid email address!')
        .trim(),
    })

    formContent = (
      <ForgotLoginNameForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        handleSubmit={handleSubmit}
        serviceError={serviceError}
      />
    )
  }

  return (
    <BaseLayout>
      <Loader visible={showLoader} />
      {formContent}
    </BaseLayout>
  )
}

export default ForgotLoginName
